export default "__VITE_ASSET__BzMZPQR8__"